import { AutogenLayoutAssignTimecardHours } from "./autogen/AutogenLayoutAssignTimecardHours";

export class AssignTimecardHours extends AutogenLayoutAssignTimecardHours {
   
}
